module.exports = __webpack_public_path__ + "img/lianwang.ea09df98.jpg";